import { FC, useState, ReactNode } from 'react';
import { ReactComponent as TriangleIcon } from 'assets/icons/triangle.svg';

interface ExpandWrapperProps {
  header: ReactNode | ((props: { isExpanded: boolean }) => ReactNode);
  className?: string;
  iconClassName?: string;
}

const ExpandWrapper: FC<ExpandWrapperProps> = ({
  header,
  className,
  children,
  iconClassName,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const api = { isExpanded };

  const headerComponent = typeof header === 'function' ? header(api) : header;

  return (
    <div className={className}>
      <div className="flex gap-x-0.8 items-center">
        <button
          className="cursor-pointer"
          onClick={() => setIsExpanded((isExpanded) => !isExpanded)}
          aria-label="Toggle expand"
        >
          <TriangleIcon
            className={`${
              isExpanded ? '' : '-rotate-90'
            } transition-transform ${iconClassName}`}
          />
        </button>
        {headerComponent}
      </div>
      {isExpanded && children}
    </div>
  );
};

export default ExpandWrapper;
